import React from 'react'

class CheckMark extends React.Component {
  render() {
    return (
      <svg className="checkMark" width="12" height="12" viewBox="0 0 12 12">
        <g fill="none" fillRule="evenodd">
          <path stroke="#979797" d="M-473.5-2897.5h2157v3361h-2157z" opacity=".05" />
          <path fillRule="nonzero" stroke="#64B512" strokeWidth="2" d="M1.5 5.881L4.546 9 10.5 3" />
        </g>
      </svg>
    )
  }
}

export default CheckMark
